const theme = {
  state: {
    options: [{
      name: 'default',
      label: '默认主题',
      themeColor: '#005ea6',
      primaryColor: '#b9daff',
      headerBackgroundColor: '#fff',
      mainBackgroundColor: '#f0f2f5',
      logoBackgroundColor: '#006de7'
    }, {
      name: 'red',
      label: '红色主题',
      themeColor: '#df3b3b',
      primaryColor: '#fde3e1',
      headerBackgroundColor: '#fff',
      mainBackgroundColor: '#f0f2f5',
      logoBackgroundColor: '#df3b3b'
    }, {
      name: 'orange',
      label: '橙色主题',
      themeColor: '#dd771c',
      primaryColor: '#fce2cb',
      headerBackgroundColor: '#fff',
      mainBackgroundColor: '#f0f2f5',
      logoBackgroundColor: '#dd771c'
    }, {
      name: 'yellow',
      label: '黄色主题',
      themeColor: '#e5a618',
      primaryColor: '#f8e6bd',
      headerBackgroundColor: '#fff',
      mainBackgroundColor: '#f0f2f5',
      logoBackgroundColor: '#e5a618'
    }, {
      name: 'green',
      label: '绿色主题',
      themeColor: '#209758',
      primaryColor: '#c2e8d1',
      headerBackgroundColor: '#fff',
      mainBackgroundColor: '#f0f2f5',
      logoBackgroundColor: '#209758'
    }, {
      name: 'dark-cyan',
      label: '墨绿主题',
      themeColor: '#03a0a6',
      primaryColor: '#bde7e9',
      headerBackgroundColor: '#fff',
      mainBackgroundColor: '#f0f2f5',
      logoBackgroundColor: '#03a0a6'
    }, {
      name: 'purple',
      label: '紫色主题',
      themeColor: '#475ec2',
      primaryColor: '#dee2f8',
      headerBackgroundColor: '#fff',
      mainBackgroundColor: '#f0f2f5',
      logoBackgroundColor: '#475ec2'
    }],
    current: '',
    style: ''
  },
  mutations: {
    chooseTheme: function (state, theme) {
      state.current = theme.name
    },
    chooseDefaultTheme: function (state) {
      state.current = 'default'
      state.style = 'brief'
    },
    chooseThemeStyle: function (state, themeStyle) {
      if (typeof themeStyle === 'string') {
        state.current = themeStyle
      } else {
        state.current = themeStyle.theme
        state.style = themeStyle.style || ''
      }
    }
  },
  getters: {
    getCurrentTheme: function (state) {
      return state.options.find(option => option.name === state.current)
    },
    getThemeByName: function (state) {
      return function (themeName) {
        return state.options.find(option => option.name === themeName)
      }
    }
  }
}

export default theme
